import {
    addNavMenuSection,
    registerCustomDetailComponent,
    registerFormInputComponent,
    Permission,
} from '@vendure/admin-ui/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { allow, onboardingGated } from './utils';
import { KeySellingPointFormComponent } from './components/key-selling-point-form.component';
import { MarketingBannerInputComponent } from './components/marketing-banner-form/marketing-banner-form.component';
import { ProductFeaturesFormComponent } from './components/product-features-form.component';
import { TaxCodeInputComponent } from './components/stripe-tax-code-form';
import { ProductVariantChannelsComponent } from './components/product-variant-channel.component';
import { HeroSectionInputComponent } from './components/hero-section-form.component';
import { RelationCollectionSelectorComponent } from './components/relation-collection-selector.component';
import { EmailSubscriptionFormComponent } from './components/email-subscription-form.component';
import { LogoSectionFormComponent } from './components/logo-section-form';
import { BannerButtonInputComponent } from './components/banner-button-form.component';
import { FulfillmentSelectFormInputComponent } from './components/fulfillment-select-form-input.component';
import { FulfillmentTextFormInputComponent } from './components/fulfillment-text-form-input.component';
import { CollectionVariantOrderFormComponent } from './components/collection-variant-order-form.component';
import { PromotionCustomFieldsLabelComponent } from './components/promotion-custom-fields-label.component';
import { FeaturedCollectionInputComponent } from './components/featured-collection-form.component';
import { NavigationColumnInputComponent } from './components/navigation-column-form.component';
import { NavigationItemInputComponent } from './components/navigation-item-form.component';
import { LayoutOptionInputComponent } from './components/layout-option-input.component';
import { ExternalHtmlContentInputComponent } from './components/external-html-content-form.component';
import { AddressFormInputComponent } from './components/address-form-input.component';
import { QAInputComponent } from './components/qa-input.component';
import { FaqListFormComponent } from './components/faq-list-form.component';
import { ProductListingComponent } from './components/product-listing-section.component';
import { ProductReviewSelectorComponent } from './components/relation-product-review-selector.component';
import { KeyPointListFormComponent } from './components/key-point-list-form.component';
import { PageComponentInputComponent } from './components/page-component-form/page-component-form.component';
import { RelationPageDisplayComponent } from './components/relation-page-display.component';
import { CollectionCarouselFormComponent } from './components/collection-carousel-form.component';
import { AboutFormComponent } from './components/about-form.component';
import { ContactFormComponent } from './components/contact-form.component';
import { WebPresenceConfigComponent } from './components/webpresence-config-form.component';
import { StorePolicyTemplatesComponent } from './components/store-policy-templates/store-policy-templates.component';
import { SiteStylesFormComponent } from './components/site-style-form/site-style-form.component';
import { HeaderMessageFormComponent } from './components/header-messages-form.component';
import { ProductReviewFormComponent } from './components/product-review-form.component';
import { TopReviewsFormComponent } from './components/top-reviews-form.component';
import { ProductInfoComponent } from './components/product-info-section.component';
import { OptionsSelectorFormComponent } from './components/options-selector-form.component';
import { ProductOptionMetaDataFormComponent } from './components/product-option-metadata-form.component';
import { ReadonlyTextareaFormInputComponent } from './components/display-only-textarea.component';
import { HiddenFormInputComponent } from './components/hidden-form-input.component';
import { EmptyInputFormComponent } from './components/empty-input-form.component';
import { RelationProductVariantSelectorComponent } from './components/product-variant-selector.component';
import { BasicCardFormComponent } from './components/basic-card-form.component';
import { CardCarouselBannerFormComponent } from './components/card-carousel-banner-form.component';
import { CountrySelectComponent } from './components/country-selector.component';
import { SimpleProductInfoComponent } from './components/simple-product-info.component';
import { ColorFormInputComponent } from './components/color-picker-form-input.component';
import { ToggleBooleanFormInputComponent } from './components/toggle-boolean-form-input.component';
import { CustomPermissions } from './ui-types';
import { CollectionGroupInputComponent } from './components/collection-group-input.component';
import { TextValueInputComponent } from './components/text-value-input.component';

export default [
    registerFormInputComponent('web-presence-config-form', WebPresenceConfigComponent),
    registerFormInputComponent('key-selling-point-form', KeySellingPointFormComponent),
    registerFormInputComponent('key-point-list-form', KeyPointListFormComponent),
    registerFormInputComponent('basic-card-form', BasicCardFormComponent),
    registerFormInputComponent('card-carousel-banner-form', CardCarouselBannerFormComponent),
    registerFormInputComponent('marketing-banner-form', MarketingBannerInputComponent),
    registerFormInputComponent('page-component-input', PageComponentInputComponent),
    registerFormInputComponent('product-listing-section-form', ProductListingComponent),
    registerFormInputComponent('product-info-section-form', ProductInfoComponent),
    registerFormInputComponent('simple-product-info-section-form', SimpleProductInfoComponent),
    registerFormInputComponent('product-features-form', ProductFeaturesFormComponent),
    registerFormInputComponent('product-review-selector', ProductReviewSelectorComponent),
    registerFormInputComponent('tax-code-form', TaxCodeInputComponent),
    registerFormInputComponent('hidden-form-input', HiddenFormInputComponent),
    registerFormInputComponent('fulfillment-select-form-input', FulfillmentSelectFormInputComponent),
    registerFormInputComponent('fulfillment-text-form-input', FulfillmentTextFormInputComponent),
    registerFormInputComponent('relation-page-display', RelationPageDisplayComponent),
    registerCustomDetailComponent({locationId: 'product-variant-detail',
        component: ProductVariantChannelsComponent,
    }),
    registerFormInputComponent('hero-section-input-form', HeroSectionInputComponent),
    registerFormInputComponent('banner-button-form', BannerButtonInputComponent),
    registerFormInputComponent('relation-collection-selector', RelationCollectionSelectorComponent),
    registerFormInputComponent('logo-section-form', LogoSectionFormComponent),
    registerFormInputComponent('email-subscription-form', EmailSubscriptionFormComponent),
    registerCustomDetailComponent({locationId: 'collection-detail',
        component: CollectionVariantOrderFormComponent,
    }),
    registerCustomDetailComponent({locationId: 'promotion-detail',
        component: PromotionCustomFieldsLabelComponent,
    }),
    registerFormInputComponent('featrued-collection-form', FeaturedCollectionInputComponent),
    registerFormInputComponent('navigation-item-input', NavigationItemInputComponent),
    registerFormInputComponent('navigation-column-input', NavigationColumnInputComponent),
    registerFormInputComponent('layout-option-input', LayoutOptionInputComponent),
    registerFormInputComponent('external-html-content-input', ExternalHtmlContentInputComponent),
    registerFormInputComponent('address-form-input', AddressFormInputComponent),
    registerFormInputComponent('question-answer-input', QAInputComponent),
    registerFormInputComponent('faq-list-form', FaqListFormComponent),
    registerFormInputComponent('collection-carousel-form', CollectionCarouselFormComponent),
    registerFormInputComponent('collection-group-input', CollectionGroupInputComponent),
    registerFormInputComponent('about-form', AboutFormComponent),
    registerFormInputComponent('contact-form', ContactFormComponent),
    registerFormInputComponent('store-policy-templates', StorePolicyTemplatesComponent),
    registerFormInputComponent('header-message-form', HeaderMessageFormComponent),
    registerFormInputComponent('site-style-form', SiteStylesFormComponent),
    registerFormInputComponent('product-reviews-form', ProductReviewFormComponent),
    registerFormInputComponent('top-reviews-form', TopReviewsFormComponent),
    registerFormInputComponent('options-selector-form', OptionsSelectorFormComponent),
    registerFormInputComponent('product-option-metadata-form', ProductOptionMetaDataFormComponent),
    registerFormInputComponent('empty-input-form', EmptyInputFormComponent),
    registerFormInputComponent('readonly-textarea-form', ReadonlyTextareaFormInputComponent),
    registerFormInputComponent('product-variant-selector', RelationProductVariantSelectorComponent),
    registerFormInputComponent('country-selector', CountrySelectComponent),
    registerFormInputComponent('color-form-input', ColorFormInputComponent),
    registerFormInputComponent('toggle-boolean-form-input', ToggleBooleanFormInputComponent),
    registerFormInputComponent('text-value-input', TextValueInputComponent),
    addNavMenuSection({
        id: 'seller-settings',
        label: 'Seller Settings',
        icon: 'settings',
        displayMode: 'settings',
        collapsible: true,
        collapsedByDefault: false,
        requiresPermission: onboardingGated(CustomPermissions.CreateCustomDomain),
        items: [
            {
                id: 'store-sites',
                label: 'My Stores',
                routerLink: ['/seller-settings', 'my-stores'],
                icon: 'store',
                requiresPermission: allow(Permission.SuperAdmin)
            },
            {
                requiresPermission: allow(Permission.UpdatePaymentMethod),
                id: 'seller-billings',
                label: 'Billings',
                routerLink: ['/seller-settings', 'billing'],
                icon: 'process-on-vm',
            },
            {
                id: 'seller-domains',
                label: 'Domains',
                icon: 'world',
                routerLink: ['/seller-settings', 'domains'],
                requiresPermission: allow(Permission.SuperAdmin),
            }
        ],
    }, 'settings'),
    addNavMenuSection({
        id: 'settings',
        label: 'Settings',
        icon: 'settings',
        displayMode: 'settings',
        collapsible: true,
        collapsedByDefault: true,
        requiresPermission: Permission.SuperAdmin,
        items: [
            {
                requiresPermission: allow(Permission.ReadSeller),
                id: 'sellers',
                label: _('nav.sellers'),
                routerLink: ['/settings', 'sellers'],
                icon: 'store',
            },
            {
                requiresPermission: allow(Permission.ReadChannel),
                id: 'channels',
                label: _('nav.channels'),
                routerLink: ['/settings', 'channels'],
                icon: 'layers',
            },
            {
                requiresPermission: allow(Permission.ReadPaymentMethod),
                id: 'payment-methods',
                label: 'Payment Methods',
                routerLink: ['/settings', 'payment-methods'],
                icon: 'credit-card',
            },
            {
                requiresPermission: allow(Permission.ReadAdministrator),
                id: 'administrators',
                label: _('nav.administrators'),
                routerLink: ['/settings', 'administrators'],
                icon: 'administrator',
            },
            {
                requiresPermission: allow(Permission.ReadAdministrator),
                id: 'roles',
                label: _('nav.roles'),
                routerLink: ['/settings', 'roles'],
                icon: 'users',
            },
            {
                requiresPermission: allow(Permission.ReadTaxCategory),
                id: 'tax-categories',
                label: _('nav.tax-categories'),
                routerLink: ['/settings', 'tax-categories'],
                icon: 'view-list',
            },
            {
                requiresPermission: allow(Permission.ReadTaxRate),
                id: 'tax-rates',
                label: _('nav.tax-rates'),
                routerLink: ['/settings', 'tax-rates'],
                icon: 'calculator',
            },
            {
                requiresPermission: allow(Permission.ReadCountry),
                id: 'countries',
                label: _('nav.countries'),
                routerLink: ['/settings', 'countries'],
                icon: 'flag',
            },
            {
                requiresPermission: allow(Permission.ReadZone),
                id: 'zones',
                label: _('nav.zones'),
                routerLink: ['/settings', 'zones'],
                icon: 'world',
            },
            {
                requiresPermission: allow(Permission.UpdateGlobalSettings),
                id: 'global-settings',
                label: _('nav.global-settings'),
                routerLink: ['/settings', 'global-settings'],
                icon: 'cog',
            },
            {
                requiresPermission: allow(Permission.SuperAdmin),
                id: 'demo-sites',
                label: 'Demo Sites',
                routerLink: ['/settings', 'demo-sites'],
                icon: 'users',
            },
        ],
    }),
];
